import { Route } from 'app/enums';
import { GuardedRoute } from 'app/interfaces/route';
import { lazyRetry } from 'app/utils';

const PlatformLinkingPage = lazyRetry(
  () => import('modules/platform-linking/pages/PlatformLinkingPage')
);

export const PlatformLinkingRoutes: GuardedRoute[] = [
  {
    path: Route.PlatformLinking,
    name: 'Platform Linking',
    component: PlatformLinkingPage,
    availability: [],
    guards: [],
  },
];
